import React from 'react';
import Button from 'epn-ui/umd/dist/components/Button';
import TooltipPro from 'epn-ui/umd/dist/components/TooltipPro';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown } from '@fortawesome/pro-regular-svg-icons/faCrown';
import { faPercent } from '@fortawesome/pro-regular-svg-icons/faPercent';
import { faGift } from '@fortawesome/pro-regular-svg-icons/faGift';
import { faTruckLoading } from '@fortawesome/pro-regular-svg-icons/faTruckLoading';
import { faShoppingCart } from '@fortawesome/pro-regular-svg-icons/faShoppingCart';
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy';
import useI18n from '@i18n';
import { ICoupon } from '@pages/coupons/interfaces';
import styles from './index.module.scss';

const formatDate = (date: string): string => {
    const stringDate = date.toString();
    return stringDate.split('-').reverse().join('.');
};

const typeToIconMap = {
    10: faPercent,
    11: faGift,
    12: faTruckLoading,
};

const sharedBadgeClasses =
    'text-blueGray-500 bg-blueGray-100 flex items-center justify-center mr-1 last:mr-0';

const Coupon: React.FC<ICoupon> = ({
    coupon,
    onClick,
    onDescriptionClick,
    handleModal,
    onCopyPromocode,
}) => {
    const {
        id,
        logo,
        promocode,
        isPersonal,
        dateFrom,
        dateTo,
        title,
        description,
        typeId,
        type,
        offerId,
        url,
    } = coupon;
    const { t } = useI18n('Coupons');
    const { t: tCommon } = useI18n('Common');

    return (
        <article className="relative flex flex-col flex-wrap w-full h-full p-3 bg-white border gap-0 xs:gap-[16px] xs:p-6 border-blueGray-200 rounded-[6px] xs:flex-row sm:flex-col md:flex-row xs:flex-nowrap">
            <div className="flex flex-row flex-wrap items-end justify-between flex-shrink-0 sm:justify-between md:justify-start xs:justify-start xs:items-center gap-0 xs:gap-[16px] xs:flex-col sm:flex-row md:flex-col sm:mr-0 sm:mb-0 md:mr-6 lg:mr-10 xs:flex-nowrap">
                <div className="flex-grow min-w-[118px] xs:flex-grow-0">
                    <img
                        className="object-cover h-10 mt-0 xs:mt-4 sm:mt-0 md:mt-4"
                        src={logo}
                        alt=""
                    />
                </div>

                {promocode && (
                    <TooltipPro title={promocode} placement="top">
                        <p className="flex-row items-center hidden px-1 py-2 text-center truncate border border-dashed rounded-[4px] xs:flex sm:hidden md:flex text-blueGray-600 h-[40px] border-blueGray-300 gap-[8px] xs:px-5 xs:w-full">
                            <button
                                type="button"
                                className="bg-transparent"
                                onClick={() => {
                                    onCopyPromocode(promocode);
                                }}
                            >
                                <FontAwesomeIcon icon={faCopy} />
                            </button>

                            <p
                                className="truncate text-blueGray-600 max-w-[61px]"
                                id={`CouponsPageCouponPromocode${id}`}
                            >
                                {promocode}
                            </p>
                        </p>
                    </TooltipPro>
                )}

                <div className="flex flex-row gap-[16px]">
                    {promocode && (
                        <button
                            type="button"
                            className="flex flex-row items-center py-2 text-center border border-dashed cursor-pointer px-[16px] max-w-[120px] w-[120px] rounded-[4px] xs:hidden sm:flex md:hidden text-blueGray-600  border-blueGray-300 gap-[8px] xs:w-full"
                            onClick={() => {
                                onCopyPromocode(promocode);
                            }}
                        >
                            <FontAwesomeIcon icon={faCopy} />
                            <p className="truncate max-w-[61px]">{promocode}</p>
                        </button>
                    )}
                    {isPersonal && (
                        <p
                            className={`${sharedBadgeClasses} static flex-grow min-w-[40px] w-[40px] ml-2 xs:ml-0 xs:absolute sm:static md:absolute right-[16px] top-[16px] h-[40px] rounded-full`}
                            title={t('Personal coupons')}
                        >
                            <FontAwesomeIcon icon={faCrown} />
                        </p>
                    )}
                </div>
            </div>
            <div className="flex flex-col items-start w-full h-auto h-full mt-4 sm:h-full md:h-auto xs:mt-0">
                <p className="mb-2 text-blueGray-500">
                    {formatDate(dateFrom)} - {formatDate(dateTo)}
                </p>
                <h3
                    id={`CouponsPageCouponDiscount${id}`}
                    className="mb-2 font-medium text-blueGray-800 text-sub line-clamp-2"
                >
                    {title}
                </h3>
                {description && (
                    /* eslint-disable */
                    <p
                        id={`CouponsPageCouponDescription${id}`}
                        className="mb-4 text-blueGray-600 text-p2 pointer xl:min-h-20 relative"
                    >
                        <p
                            className="w-full break-words max-h-[3lh] overflow-hidden relative z-0"
                            onClick={() => onDescriptionClick(description)}
                        >
                            {description}
                        </p>
                        <div className={styles.descriptionMask}></div>
                        <Button className={styles.couponLink} type="text" onClick={handleModal}>
                            {t('Show all conditions')}
                        </Button>
                    </p>
                    /* eslint-disable */
                )}
                <div className={styles.couponBottom}>
                    <div className="flex mb-6">
                        <div
                            className={`${sharedBadgeClasses} h-[32px] w-[32px] text-[14px] rounded-full `}
                            title={type}
                        >
                            <FontAwesomeIcon icon={typeToIconMap[typeId]} />
                        </div>
                    </div>
                    <div className="flex flex-row gap-[12px] xs:gap-[24px] w-full justify-between">
                        <Button
                            id={`CouponsPageCouponGetLinkButton${id}`}
                            className="w-full"
                            onClick={() => onClick(offerId, url, promocode)}
                        >
                            {tCommon('Get link')}
                        </Button>

                        <a target="_blank" href={url}>
                            <Button className="bg-red-100 min-w-[40px] px-[10px] py-[12px] rounded-full">
                                <FontAwesomeIcon icon={faShoppingCart} />
                            </Button>
                        </a>
                    </div>
                </div>
            </div>
        </article>
    );
};

export default Coupon;
